import VdpPaginationButtons from './VdpPaginationButtons';

export default VdpPaginationButtons;
